import React from "react";
import { object, func, bool } from "prop-types";
import { LazyLoadImages } from "@quintype/components";
import { StoryHeader } from "../../molecules";
import StoryElements from "../story-elements";
import "../../pages/story.m.css";
const CreatorStory = ({ story, config, adWidget, adPlaceholder, hasAccess, recommendedStories, magazineDetails }) => {
  const { headline, authors, "published-at": publishTime = "" } = story;
  return (
    <div styleName="story-template-container" className="story-holder">
      <StoryHeader
        story={story}
        headline={headline}
        storyAuthorData={authors}
        publishTime={publishTime}
        readTime={story?.["read-time"]}
        magazineDetails={magazineDetails}
      />
      <div className="story-elements">
        <div className="text-container">
          <LazyLoadImages>
            <StoryElements story={story} cards={story.cards} recommendedStories={recommendedStories} config={config} />
          </LazyLoadImages>
        </div>
      </div>
    </div>
  );
};
CreatorStory.propTypes = {
  story: object,
  config: object,
  adWidget: func,
  adPlaceholder: object,
  hasAccess: bool,
};
export default CreatorStory;
